import { gql } from "@apollo/client";

export const SAVE_ADMIN_SETTINGS = gql`
  mutation SaveAdminSettings($adminSettings: AdminSettingsInput!) {
    saveAdminSettings(adminSettings: $adminSettings) {
      api {
        corpUrl
        httpListenAddr
        url
      }
      banner
      bannerTheme
      cost {
        ebsCost {
          ebsDiscount
        }
        financeFormula
        hiddenCostProjects
        onDemandDiscount
        s3Cost {
          storage {
            archiveStorageCostDiscount
            artifactAwsAccountsWithoutLifecycleRules
            defaultMaxArtifactExpirationDays
            devprodOwnedAwsAccountIds
            iAStorageCostDiscount
            standardStorageCostDiscount
          }
          upload {
            uploadCostDiscount
          }
        }
        savingsPlanDiscount
      }
      diagnostics {
        s3BucketName
        s3Prefix
      }
      disabledGQLQueries
      hostInit {
        cloudStatusBatchSize
        hostThrottle
        maxTotalDynamicHosts
        provisioningThrottle
      }
      notify {
        ses {
          senderAddress
        }
      }
      repotracker {
        maxConcurrentRequests
        maxRepoRevisionsToSearch
        numNewRepoRevisionsToFetch
      }
      sage {
        baseUrl
      }
      scheduler {
        acceptableHostIdleTimeSeconds
        cacheDurationSeconds
        commitQueueFactor
        expectedRuntimeFactor
        futureHostFraction
        generateTaskFactor
        groupVersions
        hostAllocator
        hostAllocatorFeedbackRule
        hostAllocatorRoundingRule
        hostsOverallocatedRule
        mainlineTimeInQueueFactor
        mergeQueueTargetTimeSeconds
        numDependentsFactor
        patchFactor
        patchTimeInQueueFactor
        stepbackTaskFactor
        targetTimeSeconds
        taskFinder
        translateProjectCacheBytesLimit
        translateProjectCacheTTLSeconds
        translateProjectConcurrencyLimit
      }
      taskLimits {
        hourlyPatchTaskOverrides {
          maxHourlyPatchTasks
          projectOrRepoId
        }
        maxConcurrentLargeParserProjectTasks
        maxDailyAutomaticRestarts
        maxDegradedModeConcurrentLargeParserProjectTasks
        maxDegradedModeParserProjectSize
        maxExecTimeoutSecs
        maxGenerateTaskJSONSize
        maxHourlyPatchTasks
        maxIncludesPerVersion
        maxParserProjectSize
        maxPendingGeneratedTasks
        maxScheduledTasksPerDistro
        maxTaskExecution
        maxTasksPerVersion
        taskQueueAutoUnscheduleThreshold
      }
      ui {
        betaFeatures {
          __typename
        }
        cacheTemplates
        corsOrigins
        csrfKey
        defaultProject
        fileStreamingContentTypes
        httpListenAddr
        loginDomain
        parsleyUrl
        secret
        stagingEnvironment
        uiv2Url
        url
        userVoice
      }
    }
  }
`;
